/*!
 * 
 * react-csv-to-table v0.0.4
 * React library to show a simple table
 * 
 * Copyright (c) 2019 Marudhu Pandiyan G <marudhupandiyang@gmail.com>
 * https://github.com/marugidhupandiyang/react-csv-to-table#readme
 * 
 * Licensed under the MIT license.
 * 
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["react-csv-to-html-table"] = t(require("react")) : e["react-csv-to-html-table"] = t(e.React);
}(window, function (e) {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var a = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) {
        n.d(r, a, function (t) {
          return e[t];
        }.bind(null, a));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 1);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
      a = n.n(r);
    var o = function o(e) {
      var t = e.data,
        n = e.csvDelimiter,
        r = e.hasHeader,
        o = e.tableClassName,
        l = e.tableRowClassName,
        u = e.tableColumnClassName,
        c = e.rowKey,
        i = e.colKey,
        f = function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "\t",
            n = e.split("\n");
          return n && 0 !== n.length ? n.map(function (e) {
            return e.split(t);
          }) : [];
        }(t.trim(), n),
        s = void 0;
      r && (s = f.splice(0, 1)[0]);
      return a.a.createElement("table", {
        className: "csv-html-table ".concat(o)
      }, function (e) {
        if (e && e.map) return a.a.createElement("thead", null, a.a.createElement("tr", null, e.map(function (e, t) {
          return a.a.createElement("th", {
            key: "header-".concat(t)
          }, e);
        })));
      }(s), function (e) {
        if (e && e.map) return a.a.createElement("tbody", null, e.map(function (e, t) {
          return a.a.createElement("tr", {
            className: l,
            key: "function" == typeof c ? c(e, t) : t
          }, e.map && e.map(function (n, r) {
            return a.a.createElement("td", {
              className: u,
              key: "function" == typeof c ? i(e, r, t) : n[i]
            }, n);
          }));
        }));
      }(f));
    };
    o.defaultProps = {
      data: "",
      rowKey: function rowKey(e, t) {
        return "row-".concat(t);
      },
      colKey: function colKey(e, t, n) {
        return "col-".concat(t);
      },
      hasHeader: !0,
      csvDelimiter: "\t",
      tableClassName: "",
      tableRowClassName: "",
      tableColumnClassName: ""
    };
    var l = o;
    n.d(t, "CsvToHtmlTable", function () {
      return l;
    });
    t.default = {
      CsvToHtmlTable: l
    };
  }]);
});